import { CircularProgress } from "@mui/material";
import { Box } from "@mui/system";

const LoadingPlaceholder = ( { onClickAction }: any) => {
    return (
        <Box sx={{ width: '100%', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
             <CircularProgress />
        </Box>
    )
}

export default LoadingPlaceholder;